define('views/accounts/getdebitcard',["backbone",
        "text!views/accounts/getdebitcard.html",
        "views/_base/baseview",
        "fancybox"
], function (Backbone, Template, BaseView, FancyBox) {
    "use strict";

    return BaseView.extend({
        template: _.template(Template),
        // tagName: "section",
        id: "get-debit-card",
        isRender: true,
        needsAuth: true,
        scrollToTop: false,
        events: {
            "click #getDebit"           : "GetDebit",
            "click #cardHldrAgrmt"      : "toggleContinue",
            'click .js-skip-debit-card' : 'skipGetDebitCard'
        },
        initialize: function (options) {
            options = options || {};
            this.elementName = options.elementName;
            this.showLinkedCardSuccess = options.showLinkedCardSuccess;
            this.isModal = options.isModal;

            BaseView.prototype.initialize(this);
        },
        render: function () {
            var that = this;
                
            this.$el.html(this.template({ test: this.isModal }));

            this.$("#agreementCB").append("<label class='toggleInputLabel' for='cardHldrAgrmt'><input type='checkbox' id='cardHldrAgrmt' name='cardHldrAgrmt' value='0' />I agree to the terms of PayForward’s <a href='/cardholderagreement' target='_blank'>CardHolder Agreement</a></label>");

            this.$("#getDebit").attr('disabled', true);

            return this;
        },
        toggleContinue: function (e) {
            var agreeChkbX = e.target;

            if (agreeChkbX.checked) {
                this.$("#getDebit").removeAttr('disabled');
            }
            else {
                this.$("#getDebit").attr('disabled', true);
            }
        },
         GetDebit: function () {
            var that = this;
            if (pf.session.get("CardType") != enums.cardTypes.GPRDebitCard) {
                this.$("#getDebit").attr('disabled', true);
                this.$("#getDebit").addClass("btn-showSpinner");
                // this.$("#cancelReg").attr('disabled', true);
                this.$(".formSection").attr('disabled', true);
                $.ajax({
                    type: "POST",
                    url: pf.accountsURL + "/ConvertToGPR",
                    async: true,
                    contentType: "application/json; charset=utf-8",
                    traditional: true,
                    success: function (response) {
                        if (response) {
                            pf.session.set({ CardType: enums.cardTypes.GPRDebitCard });

                            //Navigate to success page
                            //pf.require("views/user/register/financial/success", null, null, true, function () {
                            //    require(["views/user/register/financial/success"], function (SuccessView) {
                            //        pf.show(new SuccessView({ elementName: "#mainRegion" }));
                            //    });
                            //});
                            pf.navigate("wallet/cardsuccess");
                            $.fancybox.close();
                        }
                        else
                            jAlert("There was an error trying to request a debit card. Please try again")

                        that.$(".js-getCardSpinner").addClass("hidden");
                    },
                    error: function (resp,model) {
                        that.$(".js-getCardSpinner").addClass("hidden");
                        if (resp.status == 400)
                            jAlert("There was an error trying to request a debit card. Please try again")
                    },
                    done: function (response) {
                        if (response) {
                            pf.session.set({ CardType: enums.cardTypes.GPRDebitCard });

                            //Navigate to success page
                            //pf.require("views/user/register/financial/success", null, null, true, function () {
                            //    require(["views/user/register/financial/success"], function (SuccessView) {
                            //        pf.show(new SuccessView({ elementName: "#mainRegion" }));
                            //    });
                            //});
                            pf.navigate("wallet/cardsuccess");
                            $.fancybox.close();
                        }
                        else
                            jAlert("There was an error trying to request a debit card. Please try again")

                        that.$(".js-getCardSpinner").addClass("hidden");
                    }
                });
            }
            else {
                //Navigate to success page
                //pf.require("views/user/register/financial/success", null, null, true, function () {
                //    require(["views/user/register/financial/success"], function (SuccessView) {
                //        pf.show(new SuccessView({ elementName: "#mainRegion" }));
                //    });
                //});
                pf.navigate("wallet/cardsuccess");
            }
        },
        skipGetDebitCard: function(){
            var hash = window.location.hash;
            
            if(hash.indexOf('wallet') >= 0){
                window.location.reload();
            } else {
                pf.navigate('wallet');
            }
            
        },
        close: function () {
            this.stopListening(this.model);
            this.cleanup();
        }
    });
});

